<template>
  <span>

    <a class="data-table-action"
       v-if="object.paid > 0 && !object.deleted_at"
       v-b-tooltip.hover
       @click="returnPayment"
       :title="$t('return')">
    <ReturnSvg/><span class="action-button-mob-title">{{ $t('return') }}</span>
    </a>

    <a class="data-table-action"
       v-if="!object.deleted_at"
       v-b-tooltip.hover
       :title="$t('print')">
      <b-dropdown right variant="link" no-caret>
        <template #button-content>
          <PrintSvg/><span class="action-button-mob-title">{{ $t('print') }}</span>
        </template>
        <a class="dropdown-item pointer" @click="openReceipt">
          {{ $t('receipt') }}
        </a>
        <a class="dropdown-item pointer" @click="openCheque">
          {{ $t('cheque') }}
        </a>
      </b-dropdown>
    </a>

        <a class="data-table-action"
           v-if="canSendViaWhatsApp && !object.deleted_at"
           v-b-tooltip.hover
           @click="sendReceiptToMessenger"
           :title="$t('send_receipt_to_messenger')">
          <WhatsappSvg class="svg-size-lg svg-light"/><span class="action-button-mob-title">{{ $t('send_receipt_to_messenger') }}</span>
        </a>

    <a class="data-table-action"
       v-if="object.deleted_at"
       :id="`popover-payment-${object.id}`">
    <InfoSvg class="svg-black svg-size-lg"/><span class="action-button-mob-title">{{ $t('deleted') }}</span>
    </a>

    <CustomPopover :target="`popover-payment-${object.id}`"
                   ref="popover"
                   triggers="click"
                   placement="top"
                   :arrow="false"
                   custom-class="record-popover">
      <div>
        <div class="font-weight-bold">{{ $t('deleted') }}:</div>
        <div v-if="object.deleter">{{ object.deleter.full_name }}</div>
        <div class="small text-muted">{{ formatDateTime(object.deleted_at) }}</div>
      </div>
    </CustomPopover>

    <PaymentReturnModal v-if="showReturnModal"
                        @hide="hideRefund"
                        :payment="object"/>
    </span>

</template>

<script>

import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import ReturnSvg from '@/assets/svg-vue/accounting/back.svg'
import WhatsappSvg from "@/assets/svg-vue/crm/whatsapp.svg.vue"
import InfoSvg from '@/assets/svg-vue/general/info.svg'
import JwtService from "@/services/jwt.service"
import {mapGetters, mapState} from "vuex"
import PaymentReturnModal from "@/components/parts/patients/PaymentReturnModal.vue"
import {sendReceiptToMessenger} from "@/services/payment.helper"
import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"
import { formatDateTime } from "@/extensions/filters/filters"

export default {
  name: "PaymentDatatableActions",
  components: {
    CustomPopover,
    PaymentReturnModal,
    PrintSvg,
    ReturnSvg,
    InfoSvg,
    WhatsappSvg
  },
  props: {
    object: {
      type: Object
    }
  },
  data() {
    return {
      showReturnModal: false
    }
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic
    }),
    ...mapGetters(['canSendViaWhatsApp']),
  },
  methods: {
    formatDateTime,
    openReceipt() {
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(link+'/receipt/'+this.object.id, '_blank')
    },
    openCheque() {
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(link+'/cheque/'+this.object.id, '_blank')
    },
    // openAkt() {
    //   let signer = 'manager'
    //   let link = JwtService.getPrintPrelink(this.clinic)
    //   window.open(link+'/akt/'+this.object.treatment_id+'?signer='+signer, '_blank')
    // },
    async returnPayment() {
      this.showReturnModal = true
      await this.$nextTick()
      this.$bvModal.show('payment-return-modal')
    },
    hideRefund() {
      this.showReturnModal = false
      this.$store.commit('incrementDataTableCounter')
    },
    async sendReceiptToMessenger() {
      if(!confirm(this.$t('do_you_confirm_sending_receipt_to_patient_messenger'))) return
      await sendReceiptToMessenger(this.clinic, this.object.id, this.$noty, this.$t)
    }
  }
}
</script>
